import React from 'react';
import { GoogleMap, Circle } from '@react-google-maps/api';

interface LocationMapProps {
  coordinates: {
    lat: number;
    lng: number;
  };
}

const LocationMap: React.FC<LocationMapProps> = ({ coordinates }) => {
  // Add a small random offset to hide exact location (within ~0.5 mile radius)
  const jitteredCoordinates = {
    lat: coordinates.lat + (Math.random() - 0.5) * 0.01,
    lng: coordinates.lng + (Math.random() - 0.5) * 0.01
  };

  const mapOptions = {
    disableDefaultUI: false,
    clickableIcons: false,
    scrollwheel: false,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }
    ]
  };

  const circleOptions = {
    strokeColor: '#4F46E5',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#4F46E5',
    fillOpacity: 0.15,
    radius: 800, // ~0.5 miles in meters
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    zIndex: 1
  };

  return (
    <div className="h-[400px] rounded-lg overflow-hidden shadow-sm border border-gray-200">
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '100%' }}
        center={jitteredCoordinates}
        zoom={14}
        options={mapOptions}
      >
        <Circle
          center={jitteredCoordinates}
          options={circleOptions}
        />
      </GoogleMap>
    </div>
  );
};

export default LocationMap;